import { API_BASE_URL } from "./api";

const CONSENT_STORAGE_KEY = "mib_cookie_consent_v1";
const VISITOR_STORAGE_KEY = "mib_analytics_visitor_id";
const SESSION_STORAGE_KEY = "mib_analytics_session_id";

function randomId(prefix) {
  const cryptoObj = typeof window !== "undefined" ? window.crypto : null;
  if (cryptoObj?.randomUUID) return `${prefix}_${cryptoObj.randomUUID()}`;
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
}

export function getCookieConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function getOrCreateStorageId(storage, key, prefix) {
  try {
    let value = storage.getItem(key);
    if (!value) {
      value = randomId(prefix);
      storage.setItem(key, value);
    }
    return value;
  } catch {
    return randomId(prefix);
  }
}

function resolvePublicContext(pathname) {
  const parts = String(pathname || "").split("/").filter(Boolean);
  if (parts[0] === "book" && parts[1]) return { org_slug: parts[1] };
  if (parts[0] === "studio" && parts[1]) return { studio_slug: parts[1] };
  return {};
}

export function trackPageView() {
  if (typeof window === "undefined" || window.location.pathname === "/angebot-annehmen") return;
  const consent = getCookieConsent();
  if (!consent?.analytics) return;

  const payload = {
    ...resolvePublicContext(window.location.pathname),
    event_type: "page_view",
    page_url: window.location.href,
    path: `${window.location.pathname}${window.location.search || ""}`,
    page_title: document.title || "",
    referrer: document.referrer || "",
    visitor_id: getOrCreateStorageId(window.localStorage, VISITOR_STORAGE_KEY, "vis"),
    session_id: getOrCreateStorageId(window.sessionStorage, SESSION_STORAGE_KEY, "ses"),
    screen_width: window.screen?.width || null,
    screen_height: window.screen?.height || null,
    consent_analytics: true,
  };

  try {
    const body = JSON.stringify(payload);
    const url = `${API_BASE_URL}/api/public/analytics/event`;
    const isSameOrigin = new URL(url, window.location.href).origin === window.location.origin;
    if (isSameOrigin && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      return;
    }
    fetch(url, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Analytics must never disturb booking flows.
  }
}
